import { formatPreferredDate } from './preferredDate';

export interface ShootFactsInput {
  shootType?: string;
  date?: string;
  time?: string;
  place?: string;
}

/** Shoot type, date and place. Empty pieces are left out, unless fill is set. */
export function shootFacts(input: ShootFactsInput, options?: { fill?: boolean }): { type: string; when: string; place: string; line: string } {
  const written = formatPreferredDate(input.date);
  const clock = String(input.time || '').trim();
  const when = written
    ? (clock ? `${written} at ${clock}` : written)
    : (options?.fill ? 'Date to agree' : '');
  const type = String(input.shootType || '').trim() || (options?.fill ? 'Shoot type not given' : '');
  const place = String(input.place || '').trim() || (options?.fill ? 'Place not given' : '');
  return { type, when, place, line: [type, when, place].filter(Boolean).join(' · ') };
}

/** One line for a Today card. */
export function todayShootLine(input: ShootFactsInput, options?: { fill?: boolean }): string {
  return shootFacts(input, options).line;
}

/** True once the deposit figure has been received. A quote with no deposit does not count. */
export function depositIsIn(summary?: {
  depositExpectedMinor?: number;
  depositDueMinor?: number;
  depositReceivedMinor?: number;
  receivedMinor?: number;
} | null): boolean {
  if (!summary) return false;
  const expected = Math.max(0, Math.round(Number(summary.depositExpectedMinor) || 0));
  const due = Math.max(0, Math.round(Number(summary.depositDueMinor) || 0));
  const received = Math.max(0, Math.round(Number(summary.depositReceivedMinor ?? summary.receivedMinor) || 0));
  return expected > 0 && due === 0 && received >= expected;
}

/** What Carmen still has to do when a booking is not confirmed. */
export function dateAttention(input: { hasDate: boolean; deposit?: string; depositReceived?: boolean }): string {
  if (input.depositReceived) {
    return input.hasDate
      ? 'Deposit received. Confirm the booking. The client is waiting for confirmation.'
      : 'Deposit received. Agree a date and confirm the booking. The client is waiting for confirmation.';
  }
  const step = input.hasDate ? 'Confirm the date' : 'Agree a date';
  const deposit = String(input.deposit || '').trim();
  return deposit ? `${step}. ${deposit}` : step;
}
